export default __webpack_public_path__ + "static/media/arrow_link_left.c17323fb.svg";